import React from 'react';
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { Link as RouterLink, Route, Routes } from 'react-router-dom';
import PickEmRulesPage from './PickEmRulesPage';
import PublicRulesLayout from './PublicRulesLayout';
import StockMarketRulesPage from './StockMarketRulesPage';

const LEAGUE_TYPES = [
  {
    route: 'pick-em',
    title: "Pick 'Em",
    description: 'Pick a winner for 10 games every week, against the spread.',
  },
  {
    route: 'stock-market',
    title: 'Stock Market',
    description: 'Buy and sell shares of college football teams, and earn dividends when they win.',
  },
];

function RulesIndexPage() {
  return (
    <PublicRulesLayout bgcolor="grey.100">
      <Box sx={{ maxWidth: 600, width: '100%', mt: 2, mb: 6 }}>
        <Typography variant="h5">Game Rules</Typography>
        <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
          Pick a league type to read its rules.
        </Typography>
        {LEAGUE_TYPES.map(({ route, title, description }) => (
          <Card key={route} sx={{ mb: 2, border: 1, borderColor: 'divider' }}>
            <CardActionArea component={RouterLink} to={`/rules/${route}`}>
              <CardContent>
                <Typography variant="h6">{title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </PublicRulesLayout>
  );
}

export default function PublicRules() {
  return (
    <Routes>
      <Route index element={<RulesIndexPage />} />
      <Route path="stock-market" element={<StockMarketRulesPage />} />
      <Route path="pick-em" element={<PickEmRulesPage />} />
    </Routes>
  );
}
